if (!customElements.get("td-load-more-pagination")) {
  class TDLoadMorePagination extends HTMLElement {
    constructor() {
      super();
      this.PAGE_PARAM = "page";
      this.BASE_URL = window.location.pathname;
      this.WRAPPER_SELECTOR = '.product-list-wrapper';
      this.ITEM_SELECTOR = '.product-list-wrapper .grid__item';
      this.TEXT_SELECTOR = '.td-page__text';
      this.LOADER_SELECTOR = '.td-page__loader-wrapper';
      this.RESULT_IMAGE_SELECTOR = '.card__media img';

      this.LOADER_HIDDEN_CLASS = 'td-page__loader--inactive';
      this.TEXT_HIDDEN_CLASS = 'td-page__text--inactive';
      this.ITEM_LOAD_IN_CLASS = 'td--item--load_in';

      this.ANIMATION_DELAY = 100;
      this.ITEMS_TO_EAGER_LOAD = 2;

      this.wrapper = document.querySelector(this.WRAPPER_SELECTOR);
      this.loader = this.querySelector(this.LOADER_SELECTOR);
      this.textWrapper = this.querySelector(this.TEXT_SELECTOR);

      this.isLoading = false;
      this.page = 2;
      this.initialItemCount = document.querySelectorAll(`${this.WRAPPER_SELECTOR} .grid__item`).length;
    }

    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }

    attachListeners() {
      this.addEventListener('click', this.handleLoadMore.bind(this));
    }

    handleLoadMore() {
      if (this.isLoading) return;
      
      this.isLoading = true;
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set(this.PAGE_PARAM, this.page);
      const requestUrl = `${this.BASE_URL}?${queryParams.toString()}`;
      
      if (!this.wrapper) return;

      this.textWrapper.classList.add(this.TEXT_HIDDEN_CLASS);
      this.loader.style.display = '';
      setTimeout(() => {
        this.loader.classList.remove(this.LOADER_HIDDEN_CLASS);
      }, 100);

      fetch(requestUrl)
        .then(response => response.text())
        .then(html => this.processResponse(html))
        .catch(err => console.error("Something went wrong.", err))
        .finally(() => this.finalizeLoading());
    }

    processResponse(html) {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const additionalResults = Array.from(doc.querySelectorAll(this.ITEM_SELECTOR)).slice(0, this.initialItemCount);

        if (additionalResults.length) {
          additionalResults.forEach((result, index) => {
            result.classList.add(this.ITEM_LOAD_IN_CLASS);
            if (index < this.ITEMS_TO_EAGER_LOAD) {
              const mainImage = result.querySelector(this.RESULT_IMAGE_SELECTOR);
              if (mainImage) mainImage.setAttribute('loading', 'eager');
            }
            this.wrapper.appendChild(result);
            setTimeout(() => {
              result.classList.remove(this.ITEM_LOAD_IN_CLASS);
            }, this.ANIMATION_DELAY * (index + 1));
          });
          this.page += 1;
          if (additionalResults.length < this.initialItemCount) {
            this.style.display = 'none';
          }
        }
      } catch (err) {
        console.error("Something went wrong.", err);
      }
    }

    finalizeLoading() {
      this.isLoading = false;
      if (this.loader && this.textWrapper) {
        setTimeout(() => {
          this.loader.classList.add(this.LOADER_HIDDEN_CLASS);
          this.textWrapper.style.display = '';
          this.textWrapper.classList.remove(this.TEXT_HIDDEN_CLASS);
        }, 1000);
      }
      document.dispatchEvent(new Event("td-load-more-pagination-complete"));
    }
  }
  customElements.define('td-load-more-pagination', TDLoadMorePagination);
}
